import React from 'react';
import YouTube from 'react-youtube';
import css from './YoutubePlayer.module.scss';
import { extractYouTubeVideoID } from '../../common/utils/utils';

const YoutubePlayer = ({ videoId }) => {
    const opts = {
        height: '100%',
        width: '100%'
    };
    const normalId = extractYouTubeVideoID(videoId);

    if (!normalId) return null;
    return (
        <div className={css.videoContainer}>
            <YouTube onReady={(event) => console.log(event)} videoId={normalId} opts={opts} className={css.video} />
        </div>
    );
};

export default YoutubePlayer;
